<template>
  <a :href="result.url" class="search-result">
    <div class="search-result-title" v-html="result.title"></div>
    <div class="search-result-excerpt" v-html="result.search_api_excerpt"></div>
    <div class="search-result-url">
      <i class="far fa-link"></i>
      {{ result.url.substring(1) }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    result: Object
  }
}
</script>
